import awsExport from './aws-exports.js'
import Settings from './assets/img/settings.jpg'
import CDR_V2 from './assets/img/cdrv2.png'
import AI from './assets/img/ai.jpg'

export default [
  {
    label: 'featuresSettingsTileTitle',
    value: 'setting',
    desc: 'featuresSettingsTileDescription',
    url: `${awsExport.aws_content_delivery_url}/admin-console-settings-module/index.html`,
    img: Settings,
    access: 'ADMIN ECOM',
    testId: 'administration-settings',
  },
  {
    label: 'featuresCdrv2TileTitle',
    value: 'CDR V2',
    desc: 'featuresCdrv2TileDescription',
    url: `${awsExport.aws_content_delivery_url}/admin-console-cdr-module/index.html`,
    img: CDR_V2,
    access: 'ADMIN',
    testId: 'administration-cdr-v2',
  },
  {
    label: 'AI management',
    value: 'AI',
    desc: 'AI management tools',
    url: `${awsExport.aws_content_delivery_url}/admin-console-ai-module/index.html`,
    img: AI,
    access: 'ADMIN',
    testId: 'administration-ai-v2',
  },
]
